import { apiGet, apiPost, apiPut } from "./client";
import type { NotificationLogEntry } from "@shared/types/notifications";

export const notificationsApi = {
  getAll(limit: number = 30): Promise<{ items: NotificationLogEntry[]; unread: number }> {
    return apiGet(`/api/notifications?limit=${limit}`);
  },
  getUnreadCount(): Promise<{ unread: number }> {
    return apiGet("/api/notifications/unread");
  },
  markRead(id: number): Promise<void> {
    return apiPost(`/api/notifications/${id}/read`, {});
  },
  markAllRead(): Promise<void> {
    return apiPost("/api/notifications/read-all", {});
  },
  getPreferences(): Promise<any> {
    return apiGet("/api/notifications/preferences");
  },
  updatePreferences(prefs: any): Promise<void> {
    return apiPut("/api/notifications/preferences", prefs);
  },
  subscribePush(subscription: PushSubscription): Promise<void> {
    const sub = subscription.toJSON();
    return apiPost("/api/notifications/push-subscribe", {
      endpoint: sub.endpoint,
      keys: sub.keys,
    });
  },
};
